module.exports = __webpack_public_path__ + "fonts/Inter-UI-ExtraBoldItalic.woff2";